'<template>
   <div class="page_list_container">
      <div class="list_titlebox">
         <h5 v-for="item in categoryList" v-if="item.code == typeCode">{{item.name}}</h5>
      </div>
      <div class="list_navigation max_width">
         当前位置：<router-link to="/">首页 - </router-link>
         <router-link :to="'/list/'+typeCode" v-for="item in categoryList" v-if="item.code == typeCode">{{item.name}} -
         </router-link>
         <template v-if="rCode != ''">
            <router-link :to="'/list/'+typeCode+'?rCode='+rCode" v-for="item in leftCateList" v-if="item.code == rCode">
               {{item.name}} - </router-link>
         </template><a>{{artinfo.title}}</a>
      </div>
      <div class="list_content">
         <div class="max_width">
            <div class="list_left">
               <div class="left_nav" v-if="leftCateList.length > 0">
                  <div class="l_nav_item" :class="item.code == rCode ?'active':''" v-for="(item,index) in leftCateList">
                     <router-link :to="'/list/'+typeCode +'?rCode='+item.code">
                        {{item.name}} <span class="iconfont">&#xe610;</span>
                     </router-link>
                  </div>
               </div>
               <div class="left_nav" v-if="list.length > 0">
                  <div class="l_nav_item" :class="item.code == rCode ?'active':''" v-for="(item,index) in list"
                     v-if="item.title != '联系我们'">
                     <router-link :to="'/list/'+typeCode+'/info/'+item.code+'?rCode='+item.code">
                        {{item.title}} <span class="iconfont">&#xe610;</span>
                     </router-link>
                  </div>
                  <div class="l_nav_item" v-if="typeCode == '3qYZBv'">
                     <router-link to="/list/QZJnmm">
                        制度办法 <span class="iconfont">&#xe610;</span>
                     </router-link>
                  </div>
                  <div class="l_nav_item" v-if="typeCode == '3qYZBv'">
                     <router-link to="/list/QnIje2">
                        信息公开 <span class="iconfont">&#xe610;</span>
                     </router-link>
                  </div>
                  <div class="l_nav_item" :class="item.code == rCode ?'active':''" v-for="(item,index) in list"
                     v-if="item.title == '联系我们'">
                     <router-link :to="'/list/'+typeCode+'/info/'+item.code+'?rCode='+item.code">
                        {{item.title}} <span class="iconfont">&#xe610;</span>
                     </router-link>
                  </div>
               </div>
            </div>
            <div class="list_right" v-if="artinfo != ''">
               <div class="right_detail" v-loading="loading">
                  <h5 class="detail_title">{{artinfo.title}}</h5>
                  <div class="detail_source">
                     <span v-if="artinfo.source != null">来源：{{artinfo.source}}</span>
                     <span v-if="artinfo.author != null">作者：{{artinfo.author}}</span>
                     <span> 时间：{{artinfo.createTime.substring(0,10)}}</span>
                  </div>
                  <div class="detail_desc" v-html="artinfo.content"></div>
                  <div class="detail_fileList" v-if="artinfo.artFileList.length > 0">
                     <h4>附件下载：</h4>
                     <ul>
                        <li v-for="item in artinfo.artFileList">
                           <a :href="item.url" :title="item.name">{{item.name}}</a>
                        </li>
                     </ul>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   export default {
      name: 'info_page',
      components: {},
      data() {
         return {
            loading: true,
            typeCode: '', ///分类code
            rCode: '',
            code: '',
            categoryList: [], //顶级分类
            leftCateList: [],
            artinfo: '',

            list: [],
            pageNum: 1,
            pageSize: 10,
            pagecount: 10,
         };
      },
      watch: {
         $route() {

         },
         '$route.query.code': {
            handler(newVal, oldVal) {
               //判断newVal有没有值监听路由变化
               if (this.$route.params.code) {
                  this.code = this.$route.params.code;
               } else {
                  this.code = '';
               }
            },
            deep: true
         }
      },
      mounted() {
         this.typeCode = this.$route.params.type;
         if (this.$route.query.rCode) {
            this.rCode = this.$route.query.rCode
         }
         if (this.$route.params.code) {
            this.code = this.$route.params.code
         }
         this.getCategoryList('', 1);
      },
      methods: {
         getCategoryList(code, type) {
            var _this = this;
            _this.$api.categoryList({
               parentCode: code,
            }).then(res => {
               if (res.code == 200) {
                  if (type == 1) {
                     _this.categoryList = res.data;
                     _this.getCategoryList(_this.typeCode, 2);
                  } else {
                     _this.leftCateList = res.data;
                     if (res.data.length < 1) {
                        _this.getlist();
                     } else {
                        _this.getInfo();
                     }
                  }
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function (error) {
               _this.$message.error(error.msg);
            });
         },
         openNewTab(url) {
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
         },
         getInfo() {
            var _this = this;
            _this.loading = true;
            _this.$api.artInfo({
               code: this.code,
            }).then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.artinfo = res.data;
                  document.title = _this.artinfo.title + ' ' + process.env.VUE_APP_TITLE
                  if (_this.artinfo.isOutLink == 'Y' && _this.artinfo.outLinkUrl != null && _this.artinfo
                     .outLinkUrl != '') {
                     this.openNewTab(_this.artinfo.outLinkUrl)
                  }
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function (error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
         },
         getlist() {
            var _this = this;
            _this.$api.artList({
               categoryCode: _this.typeCode,
               pageNum: _this.pageNum,
               pageSize: _this.pageSize
            }).then(res => {
               if (res.code == 200) {
                  _this.list = res.data.list;
                  _this.pagecount = res.data.total;
                  _this.getInfo();
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function (error) {
               _this.$message.error(error.msg);
            });
         },
      }
   }
</script>
<style lang="less" scoped>

</style>